import {RouterModule, Routes} from '@angular/router';

const APP_ROUTES: Routes = [
  {path: '**', redirectTo: '/module/ums/user/grid'},
];

export const routing = RouterModule.forRoot(APP_ROUTES);
